const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

const accManager = r =>
  require.ensure(
    [],
    () => r(require('@/modules/accManager/accManager.vue')),
    'accManager'
  )

const accManagerRouter = [
  {
    path: '/acc',
    name: 'acc',
    component: Layout,
    meta: {
      id: 'd778150866fb4ae5b88e235f82bc5cbd',
      auth: true,
      breadcrumbShow: false
    },
    redirect: '/acc/accManager',
    children: [
      {
        path: '/acc/accManager',
        name: 'accManager',
        component: accManager,
        meta: {
          id: 'd778150866fb4ae5b88e235f82bc5cbd',
          auth: true,
          asParams: true,
          showApp: true,
          showAll: true
        }
      }
    ]
  }
]
export default accManagerRouter



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/accManager.js